export default __webpack_public_path__ + "static/2-137f7cea7d2bfcfa9481a157ac0a44cd.jpeg";